import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import { BasePanoramaClient } from './panorama-client-base';
import { LogLevel } from '@wix/panorama-common-shared/types';

export interface PanoramaLogger {
  info(message: string, data?: Record<string, any>): void;

  warn(message: string, data?: Record<string, any>): void;

  error(message: string, data?: Record<string, any>): void;

  debug(message: string, data?: Record<string, any>): void;
}

export class PanoramaLoggerImpl implements PanoramaLogger {
  constructor(private readonly baseClient: BasePanoramaClient) {
    bindPrototypeMethodsToSelf(this);
  }

  public info(message: string, data?: Record<string, any>): void {
    this.baseClient.log(LogLevel.Info, message, data);
  }

  public warn(message: string, data?: Record<string, any>): void {
    this.baseClient.log(LogLevel.Warn, message, data);
  }

  public error(message: string, data?: Record<string, any>): void {
    this.baseClient.log(LogLevel.Error, message, data);
  }

  public debug(message: string, data?: Record<string, any>): void {
    this.baseClient.log(LogLevel.Debug, message, data);
  }
}
